import { useState } from "react";
import { faqItems } from "@/mocks/kakobuy-data";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50" id="faq">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-2">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Frequently Asked <span className="text-primary-500">Questions</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 md:px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}